import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Jede Vorwaerts-Navigation beginnt oben.
 *
 * `useScrollRestoration` schaltet die Browser-Wiederherstellung global auf `manual`, und React
 * Router setzt die Position nie selbst zurueck. Ohne diese Regel uebernahm jede Seite ohne eigenes
 * `scrollTo(0, 0)` die Position der vorigen: wer unten auf /fuer-veranstalter „Schreib uns"
 * klickte, landete auf /kontakt am Seitenende.
 *
 * Nur `PUSH`/`REPLACE`, nicht `POP`: Zurueck ueberlaesst die Position den Seiten, die sie ueber
 * `useScrollRestoration` selbst nachfuehren. Deren Restore-Lauf startet erst, wenn die Daten da
 * sind, und gewinnt damit auch bei einem Vorwaerts-Sprung auf eine Liste mit gemerkter Position.
 *
 * Alle drei Scroll-Flaechen zuruecksetzen, nicht nur `window` (30.10.2026): mit
 * `html, body { height: 100% }` scrollt auf vielen Seiten `body` selbst, und `window.scrollTo`
 * bewirkt dort nichts. Profil, „Über uns" und „Kontakt" oeffneten so mitten auf der Seite.
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  useEffect(() => {
    if (navigationType === 'POP') return;
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname, navigationType]);
  return null;
};

export default ScrollToTop;
